import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';

const honeyPotField = (form: HTMLFormElement, event: Event) => {
    const honeypot: HTMLInputElement | null = form.querySelector('[name="fax"]');
    if (honeypot && honeypot.value) {
        LoggingHandler().logUserAction('Honeypot field has been filled out', {
            searchTerm: 'honeypot-has-value',
            tags: ['forms'],
            fileName: 'honeyPotFeld.ts',
            additionalData: {
                honeyPotFieldValue: honeypot.value,
                error: event,
            },
        });
    }
};

export default honeyPotField;
